module.exports = __webpack_public_path__ + "static/TIMES-d173913d2ca12db52dfdeffeeceb6978.otf";